import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "period-selector-row"
};
const _hoisted_2 = { class: "chip-label" };
const _hoisted_3 = {
    key: 1,
    class: "period-selector-row"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "period-toggle" };
const _hoisted_6 = ["onClick"];
import { ref, watch, onMounted, nextTick } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PeriodSelector',
    props: {
        periods: {},
        modelValue: {},
        dateSelection: { default: null }
    },
    emits: ["update:modelValue", "open-drawer", "clear-selection"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const periodRefs = ref([]);
        const activeLeft = ref(2);
        const activeWidth = ref(78);
        function setPeriodRef(index, el) {
            periodRefs.value[index] = el;
        }
        function updateActivePosition() {
            const activeIndex = props.periods.findIndex(p => p.key === props.modelValue);
            if (activeIndex >= 0 && periodRefs.value[activeIndex]) {
                const el = periodRefs.value[activeIndex];
                activeLeft.value = el.offsetLeft;
                activeWidth.value = el.offsetWidth;
            }
        }
        watch(() => props.modelValue, () => {
            nextTick(updateActivePosition);
        });
        watch(() => props.dateSelection, (sel) => {
            if (!sel)
                nextTick(updateActivePosition);
        });
        onMounted(() => {
            nextTick(updateActivePosition);
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_ctx.dateSelection)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "selection-chip",
                        onClick: _cache[1] || (_cache[1] = ($event) => (emit('open-drawer')))
                    }, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "chip-calendar" }, null, -1)),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.dateSelection.label), 1),
                        _createElementVNode("div", {
                            class: "chip-close",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('clear-selection')), ["stop"]))
                        }, [
                            _createVNode(_component_v_icon, {
                                size: "8",
                                color: "white"
                            }, {
                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                    _createTextVNode("mdi-close")
                                ])),
                                _: 1
                            })
                        ])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", {
                        class: "period-icon",
                        onClick: _cache[2] || (_cache[2] = ($event) => (emit('open-drawer')))
                    }, [
                        _createElementVNode("img", {
                            src: require('@/assets/calendar.png'),
                            class: "calendar-img",
                            alt: ""
                        }, null, 8, _hoisted_4)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                            class: "period-active-bg",
                            style: _normalizeStyle({ left: activeLeft.value + 'px', width: activeWidth.value + 'px' })
                        }, null, 4),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: period.key,
                                ref_for: true,
                                ref: el => setPeriodRef(index, el),
                                class: _normalizeClass(['period-option', { selected: _ctx.modelValue === period.key }]),
                                onClick: ($event) => (emit('update:modelValue', period.key))
                            }, _toDisplayString(period.label), 11, _hoisted_6));
                        }), 128))
                    ])
                ]));
        };
    }
});
